import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { installStaleBundleReload } from '@lark-automadoc/shared-types/stale-bundle'
import { i18n } from './locales/i18n'
import { initTelemetry } from './services/telemetry'
import './style.css'

// A deploy under an open page removes the lazily loaded pages it knows;
// reload into the page asked for instead of silently ignoring the click.
installStaleBundleReload(router)

// Before mount, so a crash during app startup is still captured.
initTelemetry()

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)
app.mount('#app')
